// eslint-disable-next-line import/no-internal-modules
import ButtonControl from '@insided/deprecated-preact-components/button-control'
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
  // eslint-disable-next-line import/no-internal-modules
} from '@insided/deprecated-preact-components/modal'

interface Props {
  numberOfSelectedItems: number
  isOpen: boolean
  permanentlyDelete: () => void
  onClose: () => void
}

const PermanentlyDeleteModal = ({
  numberOfSelectedItems,
  isOpen,
  permanentlyDelete,
  onClose
}: Props) => (
  <Modal isOpen={isOpen} size='medium'>
    <ModalHeader title='Delete permanently?' onClose={() => onClose()} />
    <ModalBody>
      <div className='remove-spam-modal'>
        <p>
          {numberOfSelectedItems === 1
            ? "The selected post will be deleted permanently. Please note that you won't be able to get it back."
            : `The ${numberOfSelectedItems} selected posts will be deleted permanently. Please note that you won't be able to get them back.`}
        </p>
      </div>
    </ModalBody>
    <ModalFooter>
      <ButtonControl
        title='Delete permanently'
        newStyle
        onClick={permanentlyDelete}
        size='medium'
        variant='warning'
      />
      <ButtonControl title='Cancel' newStyle onClick={onClose} size='medium' />
    </ModalFooter>
  </Modal>
)

export default PermanentlyDeleteModal
